import * as types from './mutation-types'

export default {

  [types.SET_SELECT_ALL_STATE] (state, data) {
    state.selectAllField = data
  },

  [types.BOOTSTRAP_FUNDERS](state, funders) {
    state.funders = funders
  },
  [types.VIEW_FUNDER](state, data) {
    state.viewFunder = data
  },
  [types.SET_TOTAL_FUNDERS](state, totalFunders) {
    state.totalFunders = totalFunders
  },
  [types.SET_SELECTED_FUNDERS](state, data) {
    state.selectedFunders = data
  },
  [types.RESET_SELECTED_FUNDER](state, data) {
    state.selectedFunder = null
  },
  [types.SET_SELECT_ALL_STATE](state, data) {
    state.selectAllField = data
  }
}
